export const INVALID_PRICE_MESSAGE = 'Price is not valid for this condition';